export class AppSettings {
    public static API_URL='https://hireco.live:5150';
   //public static API_URL='http://localhost:5150';
}
